import { forwardRef, useState } from 'react';
import { Eye, EyeOff, Moon, Sun } from 'lucide-react';
import Button from '../ui/Button';
import Mark from '../ui/Mark';
import Field from '../ui/Field';
import './shell.css';

const KEY = 'hf-portal-theme';

// Auth pages on the Portal profile (DESIGN rev 2.1 §3.3): light by default with the toggle, centred single column,
// the same page for staff and external users. The tier is local to this frame; it does not touch the staff
// Console preference in hf-theme.
export default function AuthLayout({ children }) {
  const [theme, setTheme] = useState(() => { try { return localStorage.getItem(KEY) || 'light'; } catch { return 'light'; } });
  const flip = () => { const t = theme === 'light' ? 'dark' : 'light'; setTheme(t); try { localStorage.setItem(KEY, t); } catch { /* private mode */ } };
  return (
    <main className="ui ui-auth" data-theme={theme}>
      <Button className="ui-auth__theme" variant="quiet" iconOnly icon={theme === 'light' ? Moon : Sun} label={theme === 'light' ? 'Dark theme' : 'Light theme'} onClick={flip} />
      <div className="ui-auth__col">
        <div className="ui-auth__brand"><Mark wordmark /></div>
        <section className="ui-auth__card">{children}</section>
      </div>
    </main>
  );
}

// Password input with a show/hide control (keyboard reachable, labelled).
export const PasswordField = forwardRef(function PasswordField({ label, hint, error, ...rest }, ref) {
  const [show, setShow] = useState(false);
  return (
    <Field label={label} hint={hint} error={error}>
      {({ id, describedBy, invalid }) => (
        <span className="ui-pw">
          <input ref={ref} id={id} className="ui-input" type={show ? 'text' : 'password'} aria-describedby={describedBy} aria-invalid={invalid || undefined} {...rest} />
          <Button variant="quiet" iconOnly icon={show ? EyeOff : Eye} label={show ? 'Hide password' : 'Show password'} onClick={() => setShow(s => !s)} />
        </span>
      )}
    </Field>
  );
});
